export * from './example.styled';
